import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const AssetFormLocation = ({
  employees = [],
  errors = {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  locations = [],
  sublocations = [],
  t = () => {},
  values = {},
}) => {
  const [_location, ..._sublocations] = (values.location && values.location.split('.')) || [];

  // Correccion para cuando se des selecciona un empleado.
  // Sin esto deja seleccionado en el drop down al primer empleado.
  values._employee = values._employee == null ? undefined : values._employee;
  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.location')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._employee) || {}}
          isLoading={isLoading}
          name={'employee'}
          label={t('assets.fields.employee')}
          handleChange={handleValueChange}
          t={t}
          value={values._employee && values._employee.id}
        >
          {employees &&
            employees
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((employee) => (
                <option value={employee.id} key={employee.id}>
                  {employee.name} {employee.lastname} ({employee.position})
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors.location) || {}}
          isLoading={isLoading}
          name={'location'}
          label={t('assets.fields.location')}
          handleChange={handleValueChange}
          t={t}
          value={_location}
        >
          {locations &&
            locations.map((location) => (
              <option value={location.id} key={location.id}>
                {location.name}
              </option>
            ))}
        </Form.FieldSelect>
      </div>
      {sublocations &&
        sublocations
          .filter((sublocations) => sublocations.length)
          .map((sublocations, index) => (
            <div className="col-sm-6 col-md-4 col-lg-3" key={index}>
              <Form.FieldSelect
                error={(isSubmitted && errors.location) || {}}
                isLoading={isLoading}
                name={`sublocation[${index + 1}]`}
                label={`${t('assets.fields.sublocation')} ${index + 1}`}
                handleChange={handleValueChange}
                t={t}
                value={_sublocations[index]}
              >
                {sublocations &&
                  sublocations.map((sublocation) => (
                    <option value={sublocation.id} key={sublocation.id}>
                      {sublocation.name}
                    </option>
                  ))}
              </Form.FieldSelect>
            </div>
          ))}
    </div>
  );
};

export default translate()(AssetFormLocation);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormLocation.js